module.exports = __webpack_public_path__ + "static/media/photo61.7b7f87ab.jpg";